export default {
    inventario: {
        filtros: {
            tipo: {
                value: null,
                default: null,
            },
            orgao: {
                value: null,
                default: null,
            },
            mesReferencia: {
                value: null,
                default: null,
            },
            formato: {
                value: null,
                default: null,
            },
            fonteFinanciamento: {
                value: null,
                default: null
            },
            projeto: {
                value: null,
                default: null
            },
            origem: 'TODOS'
        }
    }
}
